'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _matrixJsSdk = require('matrix-js-sdk');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../../languageHandler');

var _qrcodeReact = require('qrcode-react');

var _qrcodeReact2 = _interopRequireDefault(_qrcodeReact);

var _Permalinks = require('../../../utils/permalinks/Permalinks');

var _ContextualMenu = require('../../structures/ContextualMenu');

var ContextualMenu = _interopRequireWildcard(_ContextualMenu);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2018 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var socials = [{
    name: 'Facebook',
    img: require("../../../../res/img/social/facebook.png"),
    url: function url(_url) {
        return 'https://www.facebook.com/sharer/sharer.php?u=' + _url;
    }
}, {
    name: 'Twitter',
    img: require("../../../../res/img/social/twitter-2.png"),
    url: function url(_url2) {
        return 'https://twitter.com/home?status=' + _url2;
    }
}, /* // icon missing
    name: 'Google Plus',
    img: 'img/social/',
    url: (url) => `https://plus.google.com/share?url=${url}`,
   },*/{
    name: 'LinkedIn',
    img: require("../../../../res/img/social/linkedin.png"),
    url: function url(_url3) {
        return 'https://www.linkedin.com/shareArticle?mini=true&url=' + _url3;
    }
}, {
    name: 'Reddit',
    img: require("../../../../res/img/social/reddit.png"),
    url: function url(_url4) {
        return 'http://www.reddit.com/submit?url=' + _url4;
    }
}, {
    name: 'email',
    img: require("../../../../res/img/social/email-1.png"),
    url: function url(_url5) {
        return 'mailto:?body=' + _url5;
    }
}];

var ShareDialog = function (_React$Component) {
    (0, _inherits3.default)(ShareDialog, _React$Component);

    function ShareDialog(props) {
        (0, _classCallCheck3.default)(this, ShareDialog);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ShareDialog.__proto__ || (0, _getPrototypeOf2.default)(ShareDialog)).call(this, props));

        _this.onCopyClick = _this.onCopyClick.bind(_this);
        _this.onLinkSpecificEventCheckboxClick = _this.onLinkSpecificEventCheckboxClick.bind(_this);

        _this.state = {
            // MatrixEvent defaults to share linkSpecificEvent
            linkSpecificEvent: _this.props.target instanceof _matrixJsSdk.MatrixEvent
        };
        return _this;
    }

    (0, _createClass3.default)(ShareDialog, [{
        key: 'onCopyClick',
        value: function onCopyClick(e) {
            e.preventDefault();

            ShareDialog._selectText(this.refs.link);

            var successful = void 0;
            try {
                successful = document.execCommand('copy');
            } catch (err) {
                console.error('Failed to copy: ', err);
            }

            var GenericTextContextMenu = _index2.default.getComponent('context_menus.GenericTextContextMenu');
            var buttonRect = e.target.getBoundingClientRect();

            // The window X and Y offsets are to adjust position when zoomed in to page
            var x = buttonRect.right + window.pageXOffset;
            var y = buttonRect.top + buttonRect.height / 2 + window.pageYOffset - 19;

            var _ContextualMenu$creat = ContextualMenu.createMenu(GenericTextContextMenu, {
                chevronOffset: 10,
                left: x,
                top: y,
                message: successful ? (0, _languageHandler._t)('Copied!') : (0, _languageHandler._t)('Failed to copy')
            }, false),
                close = _ContextualMenu$creat.close;
            // Drop a reference to this close handler for componentWillUnmount


            this.closeCopiedTooltip = e.target.onmouseleave = close;
        }
    }, {
        key: 'onLinkSpecificEventCheckboxClick',
        value: function onLinkSpecificEventCheckboxClick() {
            this.setState({
                linkSpecificEvent: !this.state.linkSpecificEvent
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.target instanceof _matrixJsSdk.Room) {
                var permalinkCreator = new _Permalinks.RoomPermalinkCreator(this.props.target);
                permalinkCreator.load();
                this.setState({ permalinkCreator: permalinkCreator });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // if the Copied tooltip is open then get rid of it, there are ways to close the modal which wouldn't close
            // the tooltip otherwise, such as pressing Escape or clicking X really quickly
            if (this.closeCopiedTooltip) this.closeCopiedTooltip();
        }
    }, {
        key: 'render',
        value: function render() {
            var title = void 0;
            var matrixToUrl = void 0;

            var checkbox = void 0;

            if (this.props.target instanceof _matrixJsSdk.Room) {
                title = (0, _languageHandler._t)('Share Room');

                var events = this.props.target.getLiveTimeline().getEvents();
                if (events.length > 0) {
                    checkbox = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('input', { type: 'checkbox',
                            id: 'mx_ShareDialog_checkbox',
                            checked: this.state.linkSpecificEvent,
                            onChange: this.onLinkSpecificEventCheckboxClick }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mx_ShareDialog_checkbox' },
                            (0, _languageHandler._t)('Link to most recent message')
                        )
                    );
                }

                if (this.state.linkSpecificEvent) {
                    matrixToUrl = this.state.permalinkCreator.forEvent(events[events.length - 1].getId());
                } else {
                    matrixToUrl = this.state.permalinkCreator.forRoom();
                }
            } else if (this.props.target instanceof _matrixJsSdk.User || this.props.target instanceof _matrixJsSdk.RoomMember) {
                title = (0, _languageHandler._t)('Share User');
                matrixToUrl = (0, _Permalinks.makeUserPermalink)(this.props.target.userId);
            } else if (this.props.target instanceof _matrixJsSdk.Group) {
                title = (0, _languageHandler._t)('Share Community');
                matrixToUrl = (0, _Permalinks.makeGroupPermalink)(this.props.target.groupId);
            } else if (this.props.target instanceof _matrixJsSdk.MatrixEvent) {
                title = (0, _languageHandler._t)('Share Room Message');
                checkbox = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('input', { type: 'checkbox',
                        id: 'mx_ShareDialog_checkbox',
                        checked: this.state.linkSpecificEvent,
                        onClick: this.onLinkSpecificEventCheckboxClick }),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'mx_ShareDialog_checkbox' },
                        (0, _languageHandler._t)('Link to selected message')
                    )
                );

                if (this.state.linkSpecificEvent) {
                    matrixToUrl = this.props.permalinkCreator.forEvent(this.props.target.getId());
                } else {
                    matrixToUrl = this.props.permalinkCreator.forRoom();
                }
            }

            var encodedUrl = encodeURIComponent(matrixToUrl);

            var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
            return _react2.default.createElement(
                BaseDialog,
                { title: title,
                    className: 'mx_ShareDialog',
                    contentId: 'mx_Dialog_content',
                    onFinished: this.props.onFinished
                },
                _react2.default.createElement(
                    'div',
                    { className: 'mx_ShareDialog_content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_ShareDialog_matrixto' },
                        _react2.default.createElement(
                            'a',
                            { ref: 'link',
                                href: matrixToUrl,
                                onClick: ShareDialog.onLinkClick,
                                className: 'mx_ShareDialog_matrixto_link'
                            },
                            matrixToUrl
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: matrixToUrl, className: 'mx_ShareDialog_matrixto_copy', onClick: this.onCopyClick },
                            (0, _languageHandler._t)('COPY'),
                            _react2.default.createElement(
                                'div',
                                null,
                                '\xA0'
                            )
                        )
                    ),
                    checkbox,
                    _react2.default.createElement('hr', null),
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_ShareDialog_split' },
                        _react2.default.createElement(
                            'div',
                            { className: 'mx_ShareDialog_qrcode_container' },
                            _react2.default.createElement(_qrcodeReact2.default, { value: matrixToUrl, size: 256, logoWidth: 48, logo: require("../../../../res/img/matrix-m.svg") })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'mx_ShareDialog_social_container' },
                            socials.map(function (social) {
                                return _react2.default.createElement(
                                    'a',
                                    { rel: 'noopener',
                                        target: '_blank',
                                        key: social.name,
                                        name: social.name,
                                        href: social.url(encodedUrl),
                                        className: 'mx_ShareDialog_social_icon'
                                    },
                                    _react2.default.createElement('img', { src: social.img, alt: social.name, height: 64, width: 64 })
                                );
                            })
                        )
                    )
                )
            );
        }
    }], [{
        key: '_selectText',
        value: function _selectText(target) {
            var range = document.createRange();
            range.selectNodeContents(target);

            var selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }, {
        key: 'onLinkClick',
        value: function onLinkClick(e) {
            e.preventDefault();
            var target = e.target;

            ShareDialog._selectText(target);
        }
    }]);
    return ShareDialog;
}(_react2.default.Component);

ShareDialog.propTypes = {
    onFinished: _propTypes2.default.func.isRequired,
    target: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_matrixJsSdk.Room), _propTypes2.default.instanceOf(_matrixJsSdk.User), _propTypes2.default.instanceOf(_matrixJsSdk.Group), _propTypes2.default.instanceOf(_matrixJsSdk.RoomMember), _propTypes2.default.instanceOf(_matrixJsSdk.MatrixEvent)]).isRequired
};
exports.default = ShareDialog;
module.exports = exports['default'];
//# sourceMappingURL=ShareDialog.js.map